import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import logoEduzz from 'assets/images/eduzz-logo-color.png';
import logoBlinket from 'assets/images/new-logo-blinket.svg';
import { theme } from 'assets/theme';
import Drawer, { IMenu } from 'components/Layout/Drawer';
import AsyncComponent from 'components/Shared/AsyncComponent';
import PageLoader from 'components/Shared/PageLoader';
import { hjTagging } from 'helpers/functions';
import TicketAccountIcon from 'mdi-react/TicketAccountIcon';
import React, { useEffect, useMemo, useState } from 'react';
import Helmet from 'react-helmet';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import * as Rx from 'rxjs';
import * as RxOp from 'rxjs-operators';
import authService from 'services/auth';

import styles from './styles';
import { IProps } from './types';
import userService from 'services/userService';
import attendanceListService from 'services/attendanceList';

export const ScrollTopContext = React.createContext<Function>(() => {});

const AdminPage = ({ classes }: IProps) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const fatcod = search?.get('fat_cod');

  const mainContent: React.RefObject<any> = React.createRef();
  const menu: IMenu[] = [
    {
      path: '/my-tickets',
      display: 'Meus Ingressos',
      icon: TicketAccountIcon,
      id: 'drawer-my-tickets',
    },
  ];

  const scrollTop = () => setTimeout(() => mainContent.current.scrollTo(0, 0), 100);

  useEffect(() => {
    authService
      .getUser()
      .pipe(
        RxOp.switchMap(user => {
          if (user) {
            return Rx.of(user);
          }
          return authService.getProfile().pipe(RxOp.map(response => response.data));
        }),
        RxOp.first(),
        RxOp.logError(),
      )
      .subscribe(
        user => {
          let isSupport = false;
          if (localStorage.getItem('isSupport') && localStorage.getItem('isSupport') === 'true') {
            isSupport = true;
          }
          userService.setUser({ isSupport, ...user });

          setLoading(false);
          setUser({ isSupport, ...user });

          if (user) {
            const { title, location } = document;
            const isProducer = !!user.is_producer;

            if (isProducer) {
              hjTagging(`user:uuid - ${user.id}`);
            }

            hjTagging(`user:${isProducer ? 'is' : 'not'}_producer`);
            return window.history.replaceState({}, title, `${location.origin}${location.pathname}`);
          }
        },
        () => authService.logout(),
      );
  }, []);

  useMemo(async () => {
    if (!fatcod) return;

    await attendanceListService.getEventByFatcod(fatcod).subscribe({
      next: value => {
        const { location } = document;
        return window.location.assign(`${location.origin}/my-tickets/${value.event_id}?eduzzapp=true`);
      },
      error: err => {
        attendanceListService.handleErrorMessage(err);
      },
    });
  }, [fatcod]);

  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.root}>
        {loading ? (
          <PageLoader />
        ) : (
          <ScrollTopContext.Provider value={scrollTop}>
            <Helmet>
              <title>Blinket</title>
            </Helmet>
            <Drawer menu={menu} user={user}>
              <main ref={mainContent} className={classes.content}>
                <div className={classes.toolbar} />
                <Switch>
                  <Route
                    path='/my-tickets/:id'
                    exact={true}
                    component={AsyncComponent(() => import('./MyTickets/EventSelected'))}
                  />
                  <Route exact path='/my-tickets' component={AsyncComponent(() => import('./MyTickets'))} />
                  <Redirect to='/my-tickets' />
                </Switch>
              </main>
            </Drawer>
          </ScrollTopContext.Provider>
        )}
        <div className={classes.footerDesktop}>
          <img alt='Logo da Eduzz' src={logoEduzz} className={classes.logoEduzzDesktop} />
          <div className={classes.desktopText}>
            {`Eduzz ${new Date().getFullYear()}. Todos os direitos reservados.`}
          </div>
        </div>
        <div className={classes.footerMobile}>
          <div className={classes.footerMobileImages}>
            <img alt='Logo da Blinket' src={logoBlinket} className={classes.logoBlinket} />
            <img alt='Logo da Eduzz' src={logoEduzz} className={classes.logoEduzzMobile} />
          </div>
          <div className={classes.footerMobileText}>
            {`Blinket / Eduzz ${new Date().getFullYear()}. Todos os direitos reservados.`}
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  );
};

export default withStyles(styles)(AdminPage);
